export default {
  methods: {
    /**
     * Displays toast message
     * @param type - possible values: 'info', 'success', 'error', 'warning'
     * @param params - values: 'title', 'message', 'clickable', 'time'
     * for more info, visit https://smwbtech.github.io/vue-flash-message/
     */
    toast (type = 'default', params) {
      const messageParams = {
        componentName: 'customMessage',
        status: type,
        clickable: false,
        time: 3000,
        ...params
      }
      this.flashMessage.show(messageParams)
    }
  }
}
